const URL_FRAGMENT = 'become-a-customer-form';
const FORM_QUERY = 'form[data-sc-fxb]'

const progressBar = {
  init() {
    if(window.location.pathname.toLowerCase().indexOf(URL_FRAGMENT) === -1) return;

    const progressBarEl = document.createElement('div');
    progressBarEl.classList.add('pfg-progress-bar');
    const progressBarContainer = document.createElement('div');
    progressBarContainer.classList.add('pfg-progress-bar-container');
    progressBarContainer.append(progressBarEl);

    const steps = new DocumentFragment();
    [1,2,3].forEach((el) => {
      const stepEl = document.createElement('div');
      stepEl.classList.add('step');
      if(el === 1) stepEl.classList.add('current');
      stepEl.textContent = el;
      steps.append(stepEl);
    });

    const clearProgressBar = () => {
      [...progressBarEl.children].forEach(c => c.classList.remove('current'));
      progressBarEl.classList.remove('step2', 'step3');
    };

    const updateProgressBar = () => {
      clearProgressBar();
      if(document.querySelector(`${FORM_QUERY} .form-page2`)) {
        progressBarEl.classList.add('step2');
        progressBarEl.children[1].classList.add('current');
      } else if(document.querySelector(`${FORM_QUERY} .form-page3`)) {
        progressBarEl.classList.add('step3');
        progressBarEl.children[2].classList.add('current');
      } else {
        progressBarEl.children[0].classList.add('current');
      }
    }

    progressBarEl.append(steps);
    document.querySelector(`.main-content ${FORM_QUERY}`).parentNode
      .insertBefore(progressBarContainer, document.querySelector(FORM_QUERY));
    document.querySelector('.main-content').addEventListener('click', e => {
      if(e.target.type && e.target.type.toLowerCase() === 'submit' && e.target.closest('.navigation-buttons-container')) {
        if(document.querySelector(`${FORM_QUERY} .form-page3`) && !e.target.classList.contains('cancel')) {
          progressBarContainer.remove();
        } else {
          setTimeout(updateProgressBar, 1000);
        }
      }
    });
  }
}
export default progressBar;
